import React from 'react';
export function VisionSection() {
  return <section id="vision" className="py-20 bg-[#f5f1e8]" data-id="element-133">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-134">
        <div className="lg:grid lg:grid-cols-2 lg:gap-12 items-center" data-id="element-135">
          <div className="mb-10 lg:mb-0" data-id="element-136">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-137">
              Donner une nouvelle vie à un site chargé d'histoire
            </h2>
            <p className="text-lg text-gray-700 mb-6" data-id="element-138">
              Nous transformons un ancien site minier en un pôle d'innovation
              bas carbone, conjuguant patrimoine industriel et technologies
              durables. Notre projet redonne vie à ce lieu emblématique tout en
              créant des solutions constructives d'avenir, respectueuses de
              l'environnement.
            </p>
          </div>
          <div className="relative" data-id="element-139">
            <div className="aspect-w-16 aspect-h-9 rounded-lg overflow-hidden shadow-xl" data-id="element-140">
              <div className="grid grid-cols-2 h-full" data-id="element-141">
                <div className="relative" data-id="element-142">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2sxh1fHygHWhTy1McZjm2U/image.png" alt="Bâtiment construit avec des blocs de terre compactée" className="absolute inset-0 w-full h-full object-cover" data-id="element-143" />
                  <div className="absolute bottom-0 left-0 bg-gray-900 bg-opacity-70 text-white px-3 py-1 text-sm" data-id="element-144">
                    Application
                  </div>
                </div>
                <div className="relative" data-id="element-145">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2sxh1fHygHWhTy1McZjm2U/image.png" alt="Bloc de terre compactée en cours d'installation" className="absolute inset-0 w-full h-full object-cover object-right" data-id="element-146" />
                  <div className="absolute bottom-0 right-0 bg-[#b8a077] text-white px-3 py-1 text-sm" data-id="element-147">
                    Installation
                  </div>
                </div>
              </div>
            </div>
            <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-[#e8e0cc] rounded-full z-0" data-id="element-148"></div>
            <div className="absolute -top-4 -left-4 w-32 h-32 bg-[#d6c8a9] rounded-full z-0 opacity-50" data-id="element-149"></div>
          </div>
        </div>
      </div>
    </section>;
}